// Prefixo comum de nomes de unidade ("APURE SAUDE - ARAGUARI"): vira rotulo da secao e sai dos
// titulos. Separa no primeiro hifen tolerando espacos ao redor ("APURE SAUDE -TAGUATINGA").
const SPLIT_RE = /^(.*?)\s*-\s*(.+)$/;

export function splitCommonPrefix(names) {
  const original = names.map(n => n || '');
  if (original.length < 2) return { prefix: '', names: original };
  const parts = original.map(n => {
    const m = SPLIT_RE.exec(n);
    return m && m[1].trim() && m[2].trim() ? { head: m[1].trim(), rest: m[2].trim() } : null;
  });
  if (parts.some(p => !p)) return { prefix: '', names: original };
  const norm = (s) => s.replace(/\s+/g, ' ').toLowerCase();
  if (parts.some(p => norm(p.head) !== norm(parts[0].head))) return { prefix: '', names: original };
  return { prefix: parts[0].head, names: parts.map(p => p.rest) };
}
